import { useState, useEffect } from "react";
import lunr from "lunr";
import { db, IUserSite } from "../database";

const useSearch = (searchValue: any, filter: string) => {
	const [searchResults, setSearchResults] = useState<any>();
	const [refreshCount, setRefreshCount] = useState(0);

	useEffect(() => {
		const sub = () => {
			setRefreshCount(refreshCount + 1);
		};
		db.on("changes", sub);
		//@ts-ignore
		return () => db.on("changes").unsubscribe(sub);
	}, [refreshCount]);
	useEffect(() => {
		const search = async () => {
			if (searchValue === "") {
				const foundSites = await db.userSites
					.where("status")
					.notEqual("deleted")
					.and((item) => item.status === filter || filter === ("all" || ""))
					.reverse()
					.sortBy("created");
				setSearchResults(foundSites);
				return;
			} else {
				const numberSearchValue =
					!searchValue || isNaN(parseInt(searchValue))
						? -1
						: parseInt(searchValue);
				const foundSites = await db.userSites
					.where("userSiteId")
					.equals(numberSearchValue)
					.or("name")
					.startsWithIgnoreCase(searchValue)
					.or("route")
					.equals(searchValue)
					.or("elr")
					.equals(searchValue)
					.or("mileage")
					.startsWithIgnoreCase(searchValue)
					.reverse()
					.sortBy("created");
				setSearchResults(foundSites);
				return;
			}
		};
		search();
	}, [searchValue, filter, refreshCount]);
	return searchResults;
};

export default useSearch;
